import { passwordActions } from '../redux/passwordSlice'
import { fetchHelper } from './api'

export const changePassword = ({
    email,
    oldPassword,
    newPassword,
}) => async dispatch => {
    dispatch(passwordActions.resetPasswordRequest())
    try {
        await fetchHelper.post(`Customer/ChangePassword`, {
            email,
            oldPassword,
            newPassword,
        })
        dispatch(passwordActions.resetPasswordRequestSuccess())
    } catch (e) {
        dispatch(passwordActions.resetPasswordRequestError(e.message))
    }
}
